export function pricingPlans() {
    const pricingPlans = $(".pricing-plan");
    let buttons;

    pricingPlans.each(function () {
        const $this = $(this);
        const listItems = $this.find(".check-list");
        if (listItems.find("li").hasClass("hidden")) {
            listItems.next().addClass("visible");
        }
    });

    pricingPlans.find(".show-more").click(function () {

        if ($(window).width() >= 1200) {
            buttons = pricingPlans.find(".show-more").toggleClass("active");

            if (buttons.hasClass("active")) {
                buttons.find("span").text("View less");
                buttons.prev().find(".hidden").removeClass("hidden").addClass("visible");
            } else {
                buttons.find("span").text("View more");
                buttons.prev().find(".visible").removeClass("visible").addClass("hidden");
            }
        } else {
            const $this = $(this);
            $this.toggleClass("active");
            if ($this.hasClass("active")) {
                $this.find("span").text("View less");
                $this.prev().find(".hidden").removeClass("hidden").addClass("visible");
            } else {
                $this.find("span").text("View more");
                $this.prev().find(".visible").removeClass("visible").addClass("hidden");
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/pricingPlans.js